import {isObject} from './common'

export const setLocalStorageValueByUser = (localStorageKey, msisdn, info) => {
  const infoPerUser = JSON.parse(localStorage.getItem(localStorageKey))

  if (infoPerUser && isObject(infoPerUser)) {
    localStorage.setItem(localStorageKey, JSON.stringify({...infoPerUser, [msisdn]: info}))
  } else {
    localStorage.setItem(localStorageKey, JSON.stringify({[msisdn]: info}))
  }
}

export const removeLocalStorageValueByUser = (localStorageKey, msisdn) => {
  const infoPerUser = JSON.parse(localStorage.getItem(localStorageKey))

  if (infoPerUser && isObject(infoPerUser) && infoPerUser[msisdn]) {
    const {[msisdn]: currentUserInfo, ...rest} = infoPerUser

    if (Object.keys(rest).length > 0) {
      localStorage.setItem(localStorageKey, JSON.stringify(rest))
    } else {
      localStorage.removeItem(localStorageKey)
    }

    return currentUserInfo
  }

  return null
}



// WEBPACK FOOTER //
// ./src/helpers/user.js